/**
 * A simple assert function to ensure that `value` is
 * [truthy](https://developer.mozilla.org/en-US/docs/Glossary/Truthy).
 *
 * @throws If `value` is not truthy, using the given `errorMessage`.
 * @example
 * ```
 * // instead of …
 * if (!value) {
 *   throw Error("no value found!");
 * }
 *
 * // … just
 * assertTruthy(value, "No value found");
 * ```
 */
// Note: assert functions needs an explicit type declaration, which might seem redundant.
export var assertTruthy = function assertTruthy(value, errorMessage) {
  var isTruthy = !!value;

  if (!isTruthy) {
    throw Error(errorMessage);
  }
};